import React from "react";
import { Link } from "react-router-dom";
import { ThemButton } from "../Login/Login.style";
import {
  ErrorImage,
  ErrorImgContainer,
  ErrorPageContainer,
} from "./ErrorPart.style";
import image1 from "./img/245134.jpg";

const ErrorPart = () => {
  return (
    <>
      <ErrorPageContainer>
        <ErrorImgContainer>
          <ErrorImage>
            <img src={image1} alt="" />
          </ErrorImage>
          <ThemButton
            style={{
              marginTop: "1rem",
            }}
          >
            <Link style={{ color: "#FFFFFF" }} to="/">
              Back To Home
            </Link>
          </ThemButton>
        </ErrorImgContainer>
      </ErrorPageContainer>
    </>
  );
};

export default ErrorPart;
